import { updateItems } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            最新快讯
          </h2>
          <div className="mt-4 w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">实时追踪，热点内容第一时间送达</p>
        </div>

        <div className="max-w-[800px] mx-auto relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-background-300/60 hidden md:block"></div>
          <div className="space-y-6 md:space-y-8">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-6">
                <div className="hidden md:flex flex-shrink-0 w-10 items-start justify-center pt-1">
                  <div className="w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 z-10"></div>
                </div>
                <div className="flex-1 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500">{item.time}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100/80 text-accent-700 whitespace-nowrap font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}